import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalStorage } from './local-storage.service';

@NgModule()
export class LocalStorageModule {
  static initialize(): ModuleWithProviders {
    return {
      ngModule: LocalStorageModule,
      providers: [LocalStorage],
    };
  }
}
